import { Globe, LinkIcon, Target } from '@phosphor-icons/react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_dashboard/backlink-exchange/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <div className="px-8">
        <div className="mx-auto max-w-7xl">
          {/* Main Coming Soon Section */}
          <div className="text-center py-20">
            <div className="mx-auto max-w-4xl">
              {/* Animated Icon */}
              <div className="relative mb-8">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-full blur-2xl opacity-30 animate-pulse"></div>
                <div className="relative inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full shadow-2xl animate-bounce">
                  <LinkIcon className="w-12 h-12 text-white animate-bounce" />
                </div>
              </div>

              {/* Coming Soon Badge */}
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                Coming Soon
              </div>

              {/* Main Heading */}
              <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Backlink Exchange is{' '}
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  coming soon!
                </span>
              </h2>

              {/* Description */}
              <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
                Connect with other websites to exchange backlinks and boost your
                SEO rankings. Our backlink exchange platform will automate
                backlink exchanges with our blog network.
              </p>

              {/* Features Grid */}
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-300">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                      <Target className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      Find Opportunities
                    </h3>
                  </div>
                  <p className="text-gray-600">
                    Find websites in your niche for backlink opportunities with
                    our smart matching algorithm.
                  </p>
                </div>

                <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-300">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center">
                      <Globe className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      Automated Exchange
                    </h3>
                  </div>
                  <p className="text-gray-600">
                    Send and receive backlinks automatically through our
                    streamlined platform.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
